import type { CSSProperties } from 'react';
import type { FontStyle } from '../../items/text/text-item-type';

export const turnFontStyleIntoCss = (fontStyle: FontStyle): CSSProperties => {
  return {
    ...(fontStyle.variant.toLowerCase().includes('italic')
      ? { fontStyle: 'italic' }
      : {}),
    fontWeight: fontStyle.weight,
  };
};
